import type { AxiosRequestConfig } from "axios";
import qs from "qs";
import { qsOptions } from "@/api/qsOptions";
import { axiosInstance } from "../../axios-instance";
import type { R } from "../types";
import type {
  IFlagCompanyWrongRequest,
  IFlagCompanyWrongResponse,
  IGetCompanyChangeRequestsResponse,
  IGetCurrentUserRequestsResponse,
  IGetUserRequestsRequest,
  IGetUserRequestsResponse,
  IProcessRequestRequest,
  IProcessRequestResponse,
  IRequestCompanyChangeRequest,
  IRequestCompanyChangeResponse,
} from "./types";

export class CompanyChangeService {
  async getPendingRequests(
    c?: AxiosRequestConfig,
  ): R<IGetCompanyChangeRequestsResponse> {
    try {
      return axiosInstance.get(`/api/companyChangeRequest/pending`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getUserRequests(
    p: IGetUserRequestsRequest,
    c?: AxiosRequestConfig,
  ): R<IGetUserRequestsResponse> {
    try {
      return axiosInstance.get(`/api/companyChangeRequest/user/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getCurrentUserRequests(
    c?: AxiosRequestConfig,
  ): R<IGetCurrentUserRequestsResponse> {
    try {
      return axiosInstance.get(`/api/companyChangeRequest/myRequests`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async flagWrong(
    p: IFlagCompanyWrongRequest,
    c?: AxiosRequestConfig,
  ): R<IFlagCompanyWrongResponse> {
    try {
      return axiosInstance.post(`/api/companyChangeRequest/flagWrong`, p, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async requestChange(
    p: IRequestCompanyChangeRequest,
    c?: AxiosRequestConfig,
  ): R<IRequestCompanyChangeResponse> {
    try {
      return axiosInstance.post(
        `/api/companyChangeRequest/changeCompany`,
        p,
        c,
      );
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async processRequest(
    p: IProcessRequestRequest,
    c?: AxiosRequestConfig,
  ): R<IProcessRequestResponse> {
    try {
      const params = qs.stringify(
        {
          adminResponse: p.adminResponse,
          status: p.status,
        },
        qsOptions,
      );
      return axiosInstance.post(
        `/api/companyChangeRequest/${p.id}/process?${params}`,
        p,
        c,
      );
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
